import React from 'react'
import PropTypes from 'prop-types'
import { Field, Form } from 'react-final-form'
import classNames from 'classnames'
import styles from './ticket-sites.module.scss'
import { TextInput } from '../../TextInput'
import { TextareaInput } from '../../TextareaInput'
export default function SitecostForm ({ onSubmit, disabled = false, siteId, initialValues, onClose }) {
  function handleSubmit (data, form) {
    return onSubmit({
      ...data,
      cost: parseFloat(data.cost),
      siteId
    })
  }

  function formatInitialValues (initialValues) {
    return initialValues?.cost
      ? {
          ...initialValues,
          cost: Number(initialValues?.cost).toFixed(2)
        }
      : initialValues
  }

  return (
    <Form onSubmit={handleSubmit} validate={validate} initialValues={formatInitialValues(initialValues)}>
      {({ handleSubmit, pristine, invalid, submitting, values }) => (
        <form className={classNames(styles.siteCostForm)} onSubmit={handleSubmit}>
          <Field
            name='cost'
            label='Total Cost'
            component={TextInput}
            maxLength='30'
            format={value => (value || value === 0 ? `$${value}` : '')}
            parse={value => {
              if (!value) return undefined
              return value.replace(/^\$/, '').replace(/[^\d.]/g, '')
            }}
          />
          <Field
            name='notes'
            label='Note'
            component={TextareaInput}
            maxLength='100'
          />
          <div className={styles.formButtonContainer}>
            <button
              type='button'
              className={classNames('dis-btn dis-btn-sm dis-btn-no-shadow', styles.costFormButton)}
              onClick={onClose}
              disabled={disabled}>
              Cancel
              <i className='material-icons dis-btn-icon'>clear</i>
            </button>
            <button
              type='submit'
              className={classNames('dis-btn dis-btn-primary dis-btn-sm', styles.costFormButton)}
              disabled={pristine || invalid || submitting || disabled}>
              Save
              <i className='material-icons dis-btn-icon'>check</i>
            </button>
          </div>
        </form>
      )}
    </Form>
  )
}

SitecostForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  siteId: PropTypes.string.isRequired,
  initialValues: PropTypes.object,
  onClose: PropTypes.func
}

function validate (values) {
  const errors = {}

  if (values.notes && (values.cost === null || values.cost === '')) {
    errors.cost = 'Required'
  }

  return errors
}
